import Link from 'next/link'
import React, { memo } from 'react'

import { BrandsItem } from '@/screens/Home/page/types/types'

import styles from './styles.module.scss'

interface BrandsAlphabetListProps {
	allLetters: string[]
	groupedAll: Record<string, BrandsItem[]>
	activeLetter: string | null
}

/**
 * Выводит полный список (все буквы, все бренды).
 */
export const BrandsAlphabetList = memo(function BrandsAlphabetList(props: BrandsAlphabetListProps) {
	const { allLetters, groupedAll, activeLetter } = props

	return (
		<>
			{allLetters.map(letter => {
				const brandsForLetter = groupedAll[letter]
				if (!brandsForLetter) return null

				return (
					<section key={letter} id={`letter-${letter}`} className={styles['brands-alphabet-list__block']}>
						<h3
							className={
								letter === activeLetter
									? `${styles['brands-alphabet-list__title']} ${styles['brands-alphabet-list__title--active']}`
									: styles['brands-alphabet-list__title']
							}>
							{letter}
						</h3>
						<ul className={styles['brands-alphabet-list__list']}>
							{brandsForLetter.map(brand => (
								<li key={brand.CODE} className={styles['brands-alphabet-list__list-item']}>
									<Link prefetch={false} href={`/brand/${brand.CODE}`}>
										{brand.NAME}
									</Link>
								</li>
							))}
						</ul>
					</section>
				)
			})}
		</>
	)
})
